import { createSlice } from "@reduxjs/toolkit";
import { Module } from "newModules/defaultModules";
import { OnboardingSetup } from "tools/onboarding/Onboarding.types";

export type ScopeSliceState = {
    project: string | null,
    mode: "initial" | "loadingApp" | "login" | "loadingUser" | "checkingUserOnboarding" | "initialProjectSelect" | "scopeSelect" | "loadingProject" | "checkingProjectOnboarding" | "panel" | "onboarding" | "finishingOnboarding",
    onboarding: OnboardingSetup | null,
    modules: Module[],
    rolePermissions: string[],
    projectPermissions: string[],
    scopeError?: string | null,
    orderCart?: any,
    hasLoadedProjectBefore: boolean
}

const initialState: ScopeSliceState = {
    project: null,
    mode: "initial",
    onboarding: null,
    modules: [],
    rolePermissions: [],
    projectPermissions: [],
    scopeError: null,
    orderCart: null,
    hasLoadedProjectBefore: false
}



export const scopeSlice = createSlice({
    name: "scope",
    initialState,
    reducers: {
        setMode: (state, action) => {
            state.mode = action.payload;
        },
        loadApp: (state) => {
            state.mode = "loadingApp";
        },
        doneLoadingApp: (state) => {
            state.mode = "login";
        },
        loadUser: (state) => {
            state.mode = "loadingUser";
        },
        doneCheckingUser: (state) => {
            state.mode = "initialProjectSelect";
        },
        doneLoadingUser: (state) => {
            state.mode = "checkingUserOnboarding";
        },
        loadProject: (state, action) => {
            if (state.project === action.payload.projectId) return;
            state.project = action.payload.projectId;
            state.mode = "loadingProject";
            state.modules = [];
            state.rolePermissions = [];
            state.projectPermissions = [];
            state.scopeError = null;
            state.orderCart = null;

            window.FreshworksWidget('prefill', 'ticketForm', {
                custom_fields: {
                  cf_project_id: action.payload.projectId,
                }
              })

        },
        doneLoadingProject: (state) => {
            state.mode = "checkingProjectOnboarding";
        },
        doneCheckingProject: (state) => {
            state.mode = "panel";
        },
        closeProject: (state) => {
            state.project = null;
            state.mode = "scopeSelect";
        },
        openOnboarding: (state, action) => {
            state.mode = "onboarding";
            state.onboarding = {
                type: action.payload.type,
                mode: action.payload.mode,
                params: action.payload.params,
                stateBefore: action.payload.stateBefore || {},
                location: action.payload.location || null,
            }
        },
        closeOnboarding: (state, action) => {
            state.mode = action.payload.mode || "scopeSelect";
            state.onboarding = null;
        },
        finishingOnboarding: (state) => {
            state.mode = "finishingOnboarding";
        },
        storeStateBeforeOnboarding: (state, action) => {
            if (state.onboarding) {
                state.onboarding.stateBefore = action.payload;
            }
        },
        logout: (state) => {
            state.mode = "login";
            state.project = null;
            state.onboarding = null;
            state.modules = [];
            state.rolePermissions = [];
            state.projectPermissions = [];
            state.scopeError = null;
            state.orderCart = null;
            state.hasLoadedProjectBefore = false;
        },
        setModules: (state, action) => {
            state.modules = action.payload
        },
        setPermissions: (state, action) => {
            if (action.payload.permissions) {
                state.rolePermissions = action.payload.permissions;
                state.projectPermissions = action.payload.permissions;
            } else {
                state.rolePermissions = action.payload.rolePermissions;
                state.projectPermissions = action.payload.projectPermissions;
            }
        },
        setScopeError: (state, action) => {

            console.log("Setting scope error", action.payload);

            state.scopeError = action.payload;
            state.mode = "login";
        },
        setOrderCart: (state, action) => {
            state.orderCart = action.payload;
        },
        setHasLoadedProjectBefore: (state, action) => {
            state.hasLoadedProjectBefore = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
    }

});

